// @flow
import type { Leadform, LeadformResponse } from '../../../components/types'
import { singleCrop } from '../AdvertisementDataAdapter'
import { getCustomQuestions, getStockQuestions } from '../../../components/leadforms/FormContainer'
import { putMedia } from '../media/operations'

type State = {|
  items: Array<Leadform>
|}

type InitialAction = {|
  +type: 'LEADFORMS.INIT',
  +state: State
|}

type Action = InitialAction

export type { State }

const initialState: State = {
  items: []
}

export function init(state: State): Action {
  return {
    type: 'LEADFORMS.INIT',
    state
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'LEADFORMS.INIT': {
      return action.state
    }
    default:
      return state
  }
}

export function parseResponse(response: LeadformResponse): Leadform {
  const imageStoreId = putMedia(response.image)
  return {
    id: response.id,
    name: response.name,
    vkGroup: response.vk_public,
    fbGroup: response.fb_public,
    title: response.title,
    description: response.description,
    imageStoreId,
    vkCrop: response.vk_crop && singleCrop(response.vk_crop),
    stockQuestions: getStockQuestions(response.questions),
    questions: getCustomQuestions(response.questions),
    privacyPolicyUrl: response.privacy_policy_url,
    confirmationText: response.confirmation_text
  }
}
